import axios from 'axios';

// ✅ Create Axios instance with base URL from .env
const API = axios.create({
  baseURL: process.env.REACT_APP_API || '/api', // Example: https://lotusrice.in/api
});

// ✅ Automatically attach token to every request (if present in localStorage)
API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default API;
